<template>
  <div>
    <OrderWidget :code="code"></OrderWidget>
  </div>
</template>

<script>
import OrderWidget from "@/view/pages/pay/OrderWidget";

export default {
  name: "secret-order",
  components: {
    OrderWidget,
  },
  data() {
    return {
      dialog: false,
      code: "secret",
    };
  },
};
</script>
